import { useEffect, useState } from 'react';
import { creativeAPI } from '../lib/api';

// Creative images are served only to their owner (bearer auth), so a plain
// <img src> cannot load them. Fetch with the bearer token and show an object URL.
export function AuthImage({ imageId, alt = '', className = '', ...rest }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    let cancelled = false;
    setUrl(null);
    setFailed(false);
    creativeAPI.imageBlob(imageId)
      .then((res) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [imageId]);

  if (failed) {
    return <div className={`flex items-center justify-center text-[10px] text-[var(--text-tertiary)] ${className}`} {...rest}>Image unavailable</div>;
  }
  if (!url) {
    return <div className={`animate-pulse bg-[var(--surface-sunken)] ${className}`} aria-busy="true" {...rest} />;
  }
  return <img src={url} alt={alt} className={className} {...rest} />;
}

export async function downloadCreativeImage(imageId, filename = 'martian-creative.png') {
  const res = await creativeAPI.imageBlob(imageId);
  const objectUrl = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
